import { render, staticRenderFns } from "./mastery-question-to-objective.vue?vue&type=template&id=65aba2e4&scoped=true"
import script from "./mastery-question-to-objective.ts?vue&type=script&lang=ts&external"
export * from "./mastery-question-to-objective.ts?vue&type=script&lang=ts&external"
import style0 from "./mastery-question-to-objective.less?vue&type=style&index=0&id=65aba2e4&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aba2e4",
  null
  
)

export default component.exports